import React from 'react';
import UserList from './userList';

// Simple container that just uses the existing UserList with all its functionality
const SimpleFormContainer: React.FC = () => {
  return <UserList />;
};

export default SimpleFormContainer;